import type { SVGProps } from 'react';

export const Calendar = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.3 21.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 3.5 19.7V6.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h1.4V3.15a.8.8 0 0 1 .2-.55.748.748 0 0 1 .55-.225c.233 0 .417.075.55.225.15.15.225.333.225.55V4.5H15.8V3.125c0-.2.075-.375.225-.525a.72.72 0 0 1 .525-.225c.217 0 .392.075.525.225a.72.72 0 0 1 .225.525V4.5h1.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v13.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H5.3Zm0-1.5h13.4c.067 0 .133-.033.2-.1s.1-.133.1-.2v-9.4H5v9.4c0 .067.033.133.1.2s.133.1.2.1ZM5 8.8h14V6.3c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1H5.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v2.5Zm0 0V6v2.8Z" />
    </svg>
  );
};
